import { makeAutoObservable } from 'mobx';
import { ISaveable } from '../../../../../stores/types';
import { ICredentialsStore } from '../integration-store';

export interface IGorgiasCredentials {
    api_url: string,
    username: string,
    password: string,
};

class GorgiasCredentialsStore implements ISaveable, ICredentialsStore {
    private _changes: IGorgiasCredentials = {} as IGorgiasCredentials;

    constructor() {
        makeAutoObservable(this);
    }

    public get username() { return this._changes.username; }
    public get password() { return this._changes.password; }
    public get api_url() { return this._changes.api_url; }

    public set username(v: string) { this._changes.username = v; }
    public set password(v: string) { this._changes.password = v; }
    public set api_url(v: string) { this._changes.api_url = v; }

    /** ICredentialsStore implementation ************/
    public async getCredentials() {
        return { ...this._changes };
    }


    /********* ISaveable implementation *************/
    public hasChanges(): boolean {
        return !!Object.keys(this._changes).length;
    }

    public discardChanges(): void {
        this._changes = {} as IGorgiasCredentials;
    }

    public getUpdatedModel(): IGorgiasCredentials { throw new Error('Not implemented.'); }
    public isSaving(): boolean { throw new Error('Not implemented.'); }
    public commitChanges() { throw new Error('Not implemented.'); }
    public async save() { throw new Error('Not implemented.'); }
}

export default GorgiasCredentialsStore;